import { Box, Text } from '@factorialco/deprecated-design-system'

import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'

import { APPROVED, REJECTED } from 'modules/approvals/lib/materializedApprovalFlows'

interface ContentProps {
  status: string
  finalDecisionAt: string
}

export const FinalDecision = ({ status, finalDecisionAt }: ContentProps) => {
  if ([APPROVED, REJECTED].includes(status)) {
    return (
      <Box
        padding="s16"
        border={{
          top: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
        }}
        gap="s24"
      >
        <Text.Normal size="200">
          {status}: {dateBackendDateTimeToUI(finalDecisionAt)}
        </Text.Normal>
      </Box>
    )
  }

  return null
}
